import service from "@/request/index";
const baseUrl = window.globalUrl.HOME_API;

/**
 * 获取仓单列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} [params.number] - 入库单号
 * @param {string} [params.companyName] - 仓储公司
 * @param {string} [params.categoryId] - 粮食类型
 * @returns {Promise}
 */
export function getReceiptList(params) {
  return service({
    url: `${baseUrl}/trade-website/apply/selectMyWarehouses`,
    method: "get",
    params,
  });
}

/**
 * 获取仓单贷粮食类别列表选项
 d* @returns {Promise}
 */
export function getGrainCategoryList(params) {
  return service({
    url: `${baseUrl}/trade-website/apply/selectGrainCategory`,
    method: "get",
    params,
  });
}

/**
 * 根据id获取仓单详情
 d* @returns {Promise}
 */
export function getReceiptDetailById(params) {
  return service({
    url: `${baseUrl}/trade-website/apply/selectMyWarehousesById`,
    method: "get",
    params,
  });
}

/**
 * 获取买粮人列表
 * @returns {Promise}
 */
export function getBuyersList(params) {
  return service({
    url: `${baseUrl}/trade-website/warehouse/getGrainBuyerList`,
    method: "get",
    params,
  });
}

/**
 * 新增买粮人
 * @param {Object} data - 买粮人数据
 * @param {string} data.name - 买粮人名称/姓名
 * @param {string} data.idCardNumber - 身份证号
 * @param {string} data.socialCreditCode - 统一社会信用代码
 * @param {string} data.address - 地址
 * @returns {Promise}
 */
export function addBuyer(data) {
  return service({
    url: `${baseUrl}/trade-website/warehouse/addGrainBuyer`,
    method: "post",
    data,
  });
}

/**
 * 预约出库
 * @param {Object} data - 预约数据
 * @param {string} data.receiptId - 仓单ID
 * @param {number} data.amount - 出库数量
 * @param {string} data.grainType - 粮食品种
 * @param {string} data.grainLevel - 粮食级别
 * @param {string} data.warehouseCompany - 仓储公司
 * @param {string} data.outboundTime - 出库时间
 * @param {string} data.buyerId - 买粮人ID
 * @returns {Promise}
 */
export function reserveOutbound(data) {
  return service({
    url: `${baseUrl}/trade-website/warehouse/StockOutOrderAppoint`,
    method: "post",
    data,
  });
}

/**
 * 获取仓单贷款列表
 * @param {Object} params - 查询参数
 * @param {number} params.pnum - 页码
 * @param {number} params.psize - 每页条数
 * @param {string} [params.areaCode] - 地区编码
 * @param {string} [params.status] - 状态 1-启用
 * @returns {Promise}
 */
export function getLoanList(params) {
  return service({
    url: `${baseUrl}/trade-website/financial/listSelect`,
    method: "get",
    params,
  });
}

/**
 * 获取仓单详情
 * @param {string} id - 仓单ID
 * @returns {Promise}
 */
export function getReceiptDetail(id) {
  return service({
    url: `/api/warehousing/receipt/detail/${id}`,
    method: "get",
  });
}

/**
 * 获取出入库记录
 * @param {string} receiptId - 仓单ID
 * @returns {Promise}
 */
export function getInventoryRecords(receiptId) {
  return service({
    url: `/api/warehousing/inventory/records/${receiptId}`,
    method: "get",
  });
}

/**
 * 查看预约出库详情
 * @param {*} id
 * @returns
 */
export function stockOutOrderAppointmentDetail(params) {
  return service({
    url: `${baseUrl}/trade-website/warehouse/stockOutOrderAppointmentDetail`,
    method: "get",
    params,
  });
}

export function getStockOutOrderAppointmentList(params) {
  return service({
    url: `${baseUrl}/trade-website/warehouse/companyPageList`,
    method: "post",
    data: params,
  });
}
